import { render, staticRenderFns } from "./Yhgl.vue?vue&type=template&id=c4630df6&scoped=true&"
import script from "./Yhgl.vue?vue&type=script&lang=js&"
export * from "./Yhgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4630df6",
  null
  
)

export default component.exports